import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"
import { useEffect } from "preact/hooks";

function FilterRemoveButton({ filter, className, keyword }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-color-black ${className}`}
            style="padding: 0;"
            onClick={() => {
                filter.remove();
            }}
        >
            ×
        </button>
    )
}

export default function SelectedFiltersV2() {
    const { filters, removeAll } = useProductFilters()

    useEffect(()=>{
        console.log('Terry filters', filters)
        if(filters.length > 0){
            const imageFilters = document.querySelectorAll(`#filter-image-filter .swiper-slide`);
            imageFilters.forEach((imageFilter)=>{
                const keyword = imageFilter.getAttribute('data-keyword');
                // console.log('terry keyword', keyword)
                const match = filters.some(obj => obj.value.toLowerCase() === keyword.toLowerCase());
                if (match) {
                    console.log('terry add class is active');
                    imageFilter.classList.add('is-active');
                } else {
                    imageFilter.classList.remove('is-active');
                }
            })
        } else {
            const imageFilters = document.querySelectorAll(`#filter-image-filter .swiper-slide.is-active`);
            if (imageFilters) {
                imageFilters.forEach((imageFilter)=>{
                    imageFilter.classList.remove('is-active');
                })
            }
        }
    },[filters])

    return (
        filters.length > 0 && (
            <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-selected-outer">
                <div class="ns-d-flex ns-flex-wrap ns-align-items-center gap-8 ns-selected-filters">
                    {filters.map(filter => (
                        <div
                            key={`${filter.name}: ${filter.value}`}
                            class="ns-d-flex ns-align-items-center gap-6"
                            style="background-color: #EAEAE6; padding: 2px 8px;"
                        >
                            <span class="ns-color-black text-14 font-light">{filter.value}</span>
                            <FilterRemoveButton filter={filter} keyword={filter.value}/>
                        </div>
                    ))}
                </div>
                <span
                    class=" ns-text-align-right ns-clear-all cursor-pointer"
                    style="margin-left: 8px; border: 1px solid #d9d9d9; padding: 2px 8px;"
                    onClick={() => {
                        removeAll()
                    }}
                >
                    Clear all
                </span>
            </div>
        )
    )
}
